'use client';

import { useRouter } from 'next/navigation';
import React, { Suspense, useMemo, useState } from 'react';
import { encodePassphrase, generateRoomId, randomString } from '@/lib/client-utils';
import styles from '../styles/Home.module.css';

function JoinMeetingForm() {
  const router = useRouter();
  const defaultRoomName = useMemo(() => generateRoomId(), []);
  const [roomName, setRoomName] = useState('');
  const [e2ee, setE2ee] = useState(false);
  const [sharedPassphrase, setSharedPassphrase] = useState(randomString(64));

  const startMeeting = () => {
    const room = roomName.trim() || defaultRoomName;
    if (e2ee) {
      router.push(`/rooms/${room}#${encodePassphrase(sharedPassphrase)}`);
    } else {
      router.push(`/rooms/${room}`);
    }
  };

  return (
    <div className={styles.tabContent}>
      <input
        type="text"
        placeholder={defaultRoomName}
        value={roomName}
        onChange={(ev) => setRoomName(ev.target.value)}
        onKeyDown={(ev) => ev.key === 'Enter' && startMeeting()}
      />
      <button className="lk-button" onClick={startMeeting}>
        Start Meeting
      </button>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
          <input
            id="use-e2ee"
            type="checkbox"
            checked={e2ee}
            onChange={(ev) => setE2ee(ev.target.checked)}
          />
          <label htmlFor="use-e2ee">Enable end-to-end encryption</label>
        </div>
        {e2ee && (
          <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
            <label htmlFor="passphrase">Passphrase</label>
            <input
              id="passphrase"
              type="password"
              value={sharedPassphrase}
              onChange={(ev) => setSharedPassphrase(ev.target.value)}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default function Page() {
  return (
    <>
      <main className={styles.main} data-lk-theme="default">
        <div className="header">
          <h1 className={styles.title}>LiveKit Meet</h1>
        </div>
        <Suspense fallback="Loading">
          <div className={styles.tabContainer}>
            <JoinMeetingForm />
          </div>
        </Suspense>
      </main>
      <footer data-lk-theme="default">
        Powered by{' '}
        <a href="https://hzv.fr" rel="noopener">
          Hackerzvoice
        </a>
      </footer>
    </>
  );
}
